export default "__VITE_ASSET__Cv76LQ9X__"